/* Tumbler Landing Page — Vanilla JS (converted from KodiakLandingPage.jsx) */

(function () {
  'use strict';

  /* ─── PRODUCT DATA (from Liquid) ─── */

  var PRODUCT_DATA = (function () {
    var el = document.getElementById('tl-product-data');
    if (el) { try { return JSON.parse(el.textContent); } catch (e) { /* fall through */ } }
    return { colors: [], packs: [], variants: [], images: [], color_option_index: null, pack_option_index: null };
  })();

  var COLOR_HEX_MAP = {
    'black': '#1a1a1a', 'teal': '#3ab0a2', 'navy': '#1e3a5f', 'white': '#f8f8f8',
    'charcoal': '#3d3d3d', 'red': '#c0392b', 'hot pink': '#e84393', 'coral': '#e17055',
    'mint': '#00b894', 'lavender': '#a29bfe', 'light blue': '#74b9ff', 'baby blue': '#74b9ff',
    'green': '#00a86b', 'olive green': '#6b7c3e', 'yellow': '#fdcb6e', 'maroon': '#6c2142',
    'orange': '#e17055', 'olive': '#6b7c3e', 'peach': '#fab1a0', 'slate': '#636e72',
    'rose gold': '#b76e79', 'cream': '#f5f0e8', 'pink': '#ff69b4', 'purple': '#8b5cf6',
    'lt. purple': '#c4b5fd', 'light purple': '#c4b5fd', 'grey': '#808080', 'gray': '#808080',
    'royal blue': '#2563eb'
  };
  var LIGHT_COLORS = ['white', 'cream', 'yellow', 'peach', 'lt. purple', 'light purple', 'pink', 'baby blue'];

  /* ─── STATIC REVIEW DATA ─── */
  var ALL_REVIEWS = [
    { cat: 'Repeat Business & Volume Orders', name: 'Nathan C.', text: "I was honestly skeptical at first. We opened the box less than 14 days later and WOW were we surprised! I immediately ordered more for our business and gave them out as gifts too. The tumblers feel great in your hands and keep our coffee and tea hot for hours!", img: 'https://images.loox.io/uploads/2023/9/8/9iJeeNXwc.jpg' },
    { cat: 'Repeat Business & Volume Orders', name: 'Chandra S.', text: "This is our second order. Tumblers are excellent quality.", img: 'https://images.loox.io/uploads/2024/12/20/MojjJ0q26.jpg' },
    { cat: 'Repeat Business & Volume Orders', name: 'Laura W.', text: "This was my second order with Kodiak and it showed up perfect like the last order! Will definitely continue doing business with you!", img: 'https://images.loox.io/uploads/2024/10/1/suPZy18QL.jpg' },
    { cat: 'Repeat Business & Volume Orders', name: 'Rebecca F.', text: "We have been ordering Mugs for several years now from Kodiak and are always super impressed with the quality. We are OBSESSED with the most recent order of the water bottles. They look incredible!", img: 'https://images.loox.io/uploads/2023/7/23/ynSOKJ68b.jpg' },
    { cat: 'Repeat Business & Volume Orders', name: 'Theodore N.', text: "This is my fifth or sixth set of twenty that I have ordered. I have heard nothing but compliments on how long they keep their morning coffee piping hot. Will continue to purchase these throughout my career.", img: 'https://images.loox.io/uploads/2022/5/31/N1GZ-gyuh.jpg' },
    { cat: 'Repeat Business & Volume Orders', name: 'Hal W.', text: "I\u2019ve ordered over 500 of these cups and will order more!!!", img: 'https://images.loox.io/uploads/2022/2/11/4knVk1lkh.jpg' },
    { cat: 'Repeat Business & Volume Orders', name: 'Susan M.', text: "Kodiak does a beautiful job of laser engraving! This is my second time to order in bulk for my small business and I\u2019m very pleased.", img: 'https://images.loox.io/uploads/2026/2/8/L1o8ua_JZ.jpg' },
    { cat: 'Repeat Business & Volume Orders', name: 'Richard B.', text: "I LOVE my cups! Even better \u2014 my CUSTOMERS love them! The quality of Kodiak product is amazing. I have been using them for years, and customer service is the best.", img: 'https://images.loox.io/uploads/2025/1/24/q1cIssqRM.jpg' },
    { cat: 'Repeat Business & Volume Orders', name: 'April P.', text: "This is probably my 5th order. I give these to my clients as a thank you gift. Wonderful product. Customer service is great and easy to work with.", img: 'https://images.loox.io/uploads/2024/8/25/bNDkRgn7D.jpg' },
    { cat: 'Repeat Business & Volume Orders', name: 'Gary S.', text: "Always done well, always fast and easy, this is my third order and I love them, want to try the colored ones next. Great product and company!", img: 'https://images.loox.io/uploads/2026/1/20/PW6QCuyi2.jpg' },
    { cat: 'Product Quality & Engraving', name: 'Brian W.', text: "I am so impressed! I cannot believe how detailed they got our difficult logo. This was much better than any other cup I have had made in the past!", img: 'https://images.loox.io/uploads/2024/10/3/uCcu_FiTB.jpg' },
    { cat: 'Product Quality & Engraving', name: 'Mason H.', text: "My order came out so much better than I could\u2019ve ever expected! The logo I uploaded was pretty intricate and it was seamlessly etched into my tumbler! 12/10 would recommend!", img: 'https://images.loox.io/uploads/2023/12/23/5Dt1wnmH5.jpg' },
    { cat: 'Product Quality & Engraving', name: 'Kate L.', text: "Wow!! I am beyond impressed with every aspect of this tumbler! The quality is top-notch. Because these are laser-etched, that logo is steadfast and not going anywhere!", img: 'https://images.loox.io/uploads/2023/10/13/d3bDXcxAt.jpg' },
    { cat: 'Product Quality & Engraving', name: 'Desiree S.', text: "Exceeded my expectations. Other companies didn\u2019t get the detail of my logo as well. Very impressed!", img: 'https://images.loox.io/uploads/2025/4/20/CRmG18gsE.jpg' },
    { cat: 'Product Quality & Engraving', name: 'Trevor B.', text: "Great quality cup and the detail of the engraving is exceptional!", img: 'https://images.loox.io/uploads/2025/12/7/cBFhLNwMHR.jpg' },
    { cat: 'Product Quality & Engraving', name: 'Corey P.', text: "This cup is high quality. Logo looks amazing. Definitely will be getting more.", img: 'https://images.loox.io/uploads/2025/12/18/woQOYOUgw.jpg' },
    { cat: 'Product Quality & Engraving', name: 'Jeffrey G.', text: "Came out great! Great quality and communication throughout the process.", img: 'https://images.loox.io/uploads/2026/1/29/Mpetu7j0S.jpg' },
    { cat: 'Product Quality & Engraving', name: 'Bryan A.', text: "I was extremely satisfied with the tumblers that we received from Kodiak. They are very good quality, the engraving was perfect, and the turnaround time was a lot quicker than expected.", img: 'https://images.loox.io/uploads/2025/11/14/JMGrej8_d.jpg' },
    { cat: 'Client Gifting & Brand Impressions', name: 'Emily D.', text: "I tried out a sample a few months ago. It held up amazing (even in the dishwasher). Made a larger purchase to give out to my clients and they were made and delivered within only a week!", img: 'https://images.loox.io/uploads/2025/12/6/tgD5Ht1NB.jpg' },
    { cat: 'Client Gifting & Brand Impressions', name: 'Timothy C.', text: "Love the Tumblers \u2014 they look fantastic! Having purchased these same tumblers (different logo) we couldn\u2019t be more thrilled \u2014 and so are our Clients!", img: 'https://images.loox.io/uploads/2025/2/10/9zLRZmLVm.jpg' },
    { cat: 'Client Gifting & Brand Impressions', name: 'Isis M.', text: "Extremely impressed by the quality of the product! It is beautiful and sturdy. The logo design is etched so perfectly. Very happy with this purchase!", img: 'https://images.loox.io/uploads/2025/10/22/9jfHTbgCI.jpg' },
    { cat: 'Client Gifting & Brand Impressions', name: 'Robert W.', text: "My Tumbler turned out perfect. The logo is crisp and clean and well done. It will be a great gift to give to referral partners.", img: 'https://images.loox.io/uploads/2025/4/22/8-CWMxnDg.jpg' },
    { cat: 'Client Gifting & Brand Impressions', name: 'Tabithia H.', text: "They did an amazing job. They have great customer service and care for their clients. I never pictured it would turn out so amazing. I plan to buy more.", img: 'https://images.loox.io/uploads/2025/6/19/KuVYgmNLX.jpg' },
    { cat: 'Client Gifting & Brand Impressions', name: 'Jacob F.', text: "I went out on a limb and decided to check y\u2019all out. I can honestly say this is awesome! I\u2019m definitely going to make a few more orders for giveaways.", img: 'https://images.loox.io/uploads/2025/9/28/XVFlohbNx.jpg' },
    { cat: 'Client Gifting & Brand Impressions', name: 'Dennis H.', text: "I was very happy with the way my tumblers turned out. I will be placing another order very soon for giveaways to the group.", img: 'https://images.loox.io/uploads/2025/3/23/dLsbih2kc.jpg' },
    { cat: 'Client Gifting & Brand Impressions', name: 'Eddie M.', text: "I use these as closing gifts to clients and they always seem to love them! The detail of my logo is awesome and looks great. Much better than a printed logo!", img: 'https://images.loox.io/uploads/2024/8/6/AqPqIjOcp.jpg' },
    { cat: 'Client Gifting & Brand Impressions', name: 'Erick J.', text: "I give these to my clients after every project we finish for them. Perfect design, perfect service and it was fast! I\u2019m re-ordering now! Fan for life.", img: 'https://images.loox.io/uploads/2022/8/27/EJH6HZm1T.jpg' },
    { cat: 'Client Gifting & Brand Impressions', name: 'Debra W.', text: "We were searching for a quality gift for our Real Estate clients. These Kodiak cups are really stunning! The engraving looks very rich and I know our clients will enjoy them for years.", img: 'https://images.loox.io/uploads/2023/3/1/l_nprRqfL.jpg' },
    { cat: 'Client Gifting & Brand Impressions', name: 'Keith S.', text: "Our clients LOVE these tumblers. Everyone who gets one from us is thrilled \u2014 you want to give people something they actually want to use instead of some chintzy cheap promo item.", img: 'https://images.loox.io/uploads/2023/9/3/f1R0oUX8p.jpg' },
    { cat: 'Client Gifting & Brand Impressions', name: 'Brandon W.', text: "These turned out GREAT! I use these in my closing gift baskets for my clients. They love them and it keeps me in front of them for a long time.", img: 'https://images.loox.io/uploads/2021/11/19/N1g_V_hxOi.jpg' },
    { cat: 'Client Gifting & Brand Impressions', name: 'Michelle F.', text: "Super excited to give these travel mugs out as client gifts! The quality is excellent and the whole order process was easy start to finish. Would definitely order again.", img: 'https://images.loox.io/uploads/2022/8/27/4yB3J_Q1T.jpg' },
    { cat: 'Client Gifting & Brand Impressions', name: 'Joel H.', text: "Want your clients to think of your business? How about give them their new favorite coffee mug? My clients thank me while they are advertising for me. Win win!", img: 'https://images.loox.io/uploads/2021/2/1/NJeJ7LHegq.jpg' },
    { cat: 'Client Gifting & Brand Impressions', name: 'Ken W.', text: "These are consistent with every other product we have ordered from Kodiak \u2014 amazing quality & fantastic value. We literally can\u2019t keep them on the shelves! Our clients LOVE them!", img: 'https://images.loox.io/uploads/2019/9/10/N1XUIbeIw.jpg' },
    { cat: 'Ordering Process & Customer Service', name: 'Jamika M.', text: "Clear communication and fast shipping! I\u2019ll be ordering in bulk!", img: 'https://images.loox.io/uploads/2026/1/13/tfWNp7uso.jpg' },
    { cat: 'Ordering Process & Customer Service', name: 'Steven B.', text: "Great job with the RWB mugs... super fast delivery time too. KODIAK is my GO TO.", img: 'https://images.loox.io/uploads/2026/3/2/eDmbYGCz-.jpg' },
    { cat: 'Ordering Process & Customer Service', name: 'Kris B.', text: "The customer service was absolutely great. They answered multiple emails very quickly. They were able to send me a proof so I knew exactly what I was receiving. Very impressed with the quality.", img: 'https://images.loox.io/uploads/2026/2/3/3IFvqwioF.jpg' },
    { cat: 'Ordering Process & Customer Service', name: 'Matthew D.', text: "The entire ordering process was very simple and Courtney made sure my logo was perfect before sending it to production. Overall, I am very happy with the product!", img: 'https://images.loox.io/uploads/2026/2/16/k84SeO1vT.jpg' },
    { cat: 'Ordering Process & Customer Service', name: 'Bradley S.', text: "Super great experience from beginning to end! The proofs were spot on with the end product and the communications throughout the process were clear. Super happy!", img: 'https://images.loox.io/uploads/2023/9/21/BSukMdbYU.jpg' },
    { cat: 'Ordering Process & Customer Service', name: 'Shanna C.', text: "Absolutely love the Tumblers they made with my logo. The shipping was extremely fast and I loved that they made sure they had the correct logo before sending to production.", img: 'https://images.loox.io/uploads/2023/3/18/kGFJ4MXIr.jpg' },
    { cat: 'Ordering Process & Customer Service', name: 'Alan M.', text: "This was such an easy experience. Communication was great. Speedy delivery and tracking. I was so happy I ordered twice. Definitely a new and solid vendor for us.", img: 'https://images.loox.io/uploads/2023/8/26/6sUqH0Mjd.jpg' },
    { cat: 'Ordering Process & Customer Service', name: 'Becke O.', text: "Easy ordering process and their products are solid! The engraving is perfect! The order specialists are super responsive. I get so many compliments on the tumblers!", img: 'https://images.loox.io/uploads/2023/2/6/4k1saYJ5Ir.jpg' },
    { cat: 'Ordering Process & Customer Service', name: 'Matthew O.', text: "The pricing is too good to be true \u2014 this is a high quality professional level product with excellent customer service.", img: 'https://images.loox.io/uploads/2019/10/29/VyAH0H-5P.jpg' },
    { cat: 'Resale & Retail Performance', name: 'Rebecca C.', text: "The quality of these cups is amazing! They were a huge hit in my business and I sold out of my order in 3 days. The detail on the engraving is excellent.", img: 'https://images.loox.io/uploads/2020/7/14/N1JKjeIkt.jpg' },
    { cat: 'Resale & Retail Performance', name: 'Kimber W.', text: "I have almost sold out of these \u2014 they have been going off the shelf like crazy!!! Fast turn around time and delivery. I will be ordering again.", img: 'https://images.loox.io/uploads/2021/6/11/VkyP9q3qc.jpg' },
    { cat: 'Resale & Retail Performance', name: 'Mitchell M.', text: "Once they came in I was very pleased with the results! Sold 8 cups the 1st day!", img: 'https://images.loox.io/uploads/2022/6/10/4kL4R5o_2.jpg' },
    { cat: 'Resale & Retail Performance', name: 'Abby O.', text: "They sold off the shelf the first day I received them. I have more on order. Very pleased with the quality of the 20oz tumbler.", img: 'https://images.loox.io/uploads/2022/10/11/V1gh_hhAGa.jpg' },
    { cat: 'Resale & Retail Performance', name: 'Hannah R.', text: "Love these cups!! They are selling like hotcakes. Customer service took care of a short shipment right away. Very happy and will be ordering more!", img: 'https://images.loox.io/uploads/2022/6/22/E15Pee2F3.jpg' },
    { cat: 'Resale & Retail Performance', name: 'Kirstie S.', text: "Absolutely IN LOVE WITH THESE AT OUR SHOP! Thank y\u2019all!", img: 'https://images.loox.io/uploads/2025/5/25/bSpwc0Q6S.jpg' },
    { cat: 'Resale & Retail Performance', name: 'Kesha B.', text: "I absolutely love these tumblers! The ordering process was very easy and I received a beautiful product. I\u2019ve only had these for a few weeks and have already sold out!", img: 'https://images.loox.io/uploads/2022/4/24/N1RMdiaN3.jpg' },
    { cat: 'Resale & Retail Performance', name: 'Wendy S.', text: "We sell them at our business and they are a huge hit!", img: 'https://images.loox.io/uploads/2023/10/31/mhmm422uSf.jpg' },
    { cat: 'Resale & Retail Performance', name: 'Karvell D.', text: "I love how fast everything was. The quality is top notch and makes one feel comfortable selling to their customers.", img: 'https://images.loox.io/uploads/2023/11/16/0E2oJhrwq.jpg' },
    { cat: 'Resale & Retail Performance', name: 'Derrick F.', text: "Easy ordering process, great customer service, sturdy construction and eye-catching artwork. Very pleased and will order more. Great addition to my inventory!", img: 'https://images.loox.io/uploads/2025/1/18/-JfEEx8DS.jpg' },
    { cat: 'Resale & Retail Performance', name: 'Brian L.', text: "Our members loved the deep purple tumblers. Sold like hotcakes!", img: 'https://images.loox.io/uploads/2025/10/5/wV7PV6cqf.jpg' },
    { cat: 'Resale & Retail Performance', name: 'Marius P.', text: "I tried Kodiak tumblers in my online store and a customer left this review: \u2018Great quality, awesome price! Solidly built, and the graphic is etched, not affixed.\u2019 \u2014 that says it all.", img: 'https://images.loox.io/uploads/2023/4/20/vVvpsIs6z.jpg' },
    { cat: 'Resale & Retail Performance', name: 'Atarri H.', text: "Our entire travel ball organization loves these cups. They work just as good as the top selling brands \u2014 and we have ordered multiple times already.", img: 'https://images.loox.io/uploads/2021/10/27/EJWUhtZUi.jpg' }
  ];

  var REVIEW_CATEGORIES = [];
  var catCounts = {};
  ALL_REVIEWS.forEach(function (r) {
    if (!catCounts[r.cat]) { catCounts[r.cat] = 0; REVIEW_CATEGORIES.push(r.cat); }
    catCounts[r.cat]++;
  });

  var COLORS = PRODUCT_DATA.colors.map(function (name) {
    var key = name.toLowerCase();
    return { name: name, hex: COLOR_HEX_MAP[key] || '#888888', light: LIGHT_COLORS.indexOf(key) !== -1 };
  });

  if (COLORS.length === 0) {
    COLORS = [{ name: 'Black', hex: '#1a1a1a' }];
  }

  var COLOR_IMAGES = {};
  var colorIdx = PRODUCT_DATA.color_option_index;
  if (colorIdx !== null) {
    PRODUCT_DATA.variants.forEach(function (v) {
      if (v.image && v.options && v.options[colorIdx]) {
        var cName = v.options[colorIdx];
        if (!COLOR_IMAGES[cName]) COLOR_IMAGES[cName] = v.image;
      }
    });
  }
  if (PRODUCT_DATA.all_images && PRODUCT_DATA.all_images.length) {
    COLORS.forEach(function (c) {
      if (COLOR_IMAGES[c.name]) return;
      var key = c.name.toLowerCase();
      var match = PRODUCT_DATA.all_images.find(function (img) {
        return img.alt && img.alt.toLowerCase().indexOf(key) !== -1;
      });
      if (match) COLOR_IMAGES[c.name] = match.src;
    });
  }

  function buildTiers() {
    var packs = PRODUCT_DATA.packs;
    var variants = PRODUCT_DATA.variants;
    var packIdx = PRODUCT_DATA.pack_option_index;
    if (!packs.length) return [{ id: 'default', name: '24 Units', units: 24, perUnit: 13.95, maxColors: 99, features: ['Free digital proof', 'Unlimited revisions'], freeShipping: false }];

    return packs.map(function (packLabel, i) {
      var packNum = parseInt(packLabel.replace(/[^0-9]/g, ''), 10) || 24;
      var variant = null;
      for (var v = 0; v < variants.length; v++) {
        if (packIdx !== null && variants[v].options[packIdx] === packLabel) { variant = variants[v]; break; }
      }
      var priceInCents = variant ? variant.price : (packNum * 1395);
      var perUnit = priceInCents / 100 / packNum;
      var totalPrice = priceInCents / 100;
      var freeShipping = packNum >= 50;
      var maxColors;
      if (packNum <= 12) maxColors = 1;
      else if (packNum <= 24) maxColors = 4;
      else if (packNum <= 48) maxColors = 6;
      else maxColors = COLORS.length;

      var features = [packNum + ' laser-engraved tumblers', 'Free digital proof in 24hrs', 'Unlimited revisions'];
      if (maxColors <= 10) features.splice(1, 0, 'Mix up to ' + maxColors + ' colors');
      else features.splice(1, 0, 'Unlimited colors');
      if (freeShipping) features.push('Free UPS shipping');
      if (packNum >= 72) features.push('Dedicated account rep');
      if (packNum >= 96) features.push('Free branded client storefront');

      return {
        id: packLabel.toLowerCase().replace(/\s+/g, '-'),
        name: packLabel,
        units: packNum,
        perUnit: Math.round(perUnit * 100) / 100,
        totalPrice: totalPrice,
        maxColors: maxColors,
        features: features,
        freeShipping: freeShipping,
        popular: i === 1,
        variantId: variant ? variant.id : null
      };
    });
  }

  var TIERS = buildTiers();

  var ADDON_DATA = PRODUCT_DATA.addons || {};
  var ADDONS = [
    { id: 'priority', name: 'Priority Processing', desc: 'Jump the queue — your order ships within 1 business day instead of 2-3.', icon: '⚡', price: ADDON_DATA.priority ? ADDON_DATA.priority.price : 4 },
    { id: 'backside', name: 'Backside Engraving', desc: 'Add a second design, your company tagline, or personalized names on the back of each tumbler.', icon: '🔄', price: ADDON_DATA.backside ? ADDON_DATA.backside.price : 4 },
    { id: 'slider', name: 'Slider Lid Upgrade', desc: 'Premium magnetic slider lid — spill-proof for desks and cars. Huge client favorite.', icon: '🔒', price: ADDON_DATA.slider ? ADDON_DATA.slider.price : 2 }
  ];

  var BACKSIDE_FONTS = [
    { name: 'Serif', style: 'Georgia, serif' },
    { name: 'Sans', style: "'DM Sans', sans-serif" },
    { name: 'Script', style: "'Brush Script MT', cursive" },
    { name: 'Mono', style: "'Courier New', monospace" }
  ];

  var PRODUCT_IMAGES = PRODUCT_DATA.images || [];

  var SHOP_URL = PRODUCT_DATA.product_url || '/cart';

  /* ─── STATE ─── */

  var firstColor = COLORS[0] ? COLORS[0].name : 'Black';
  var firstTierUnits = TIERS[0] ? TIERS[0].units : 24;
  var initQtys = {};
  initQtys[firstColor] = firstTierUnits;

  var state = {
    tierIdx: 0,
    selectedColors: [firstColor],
    colorQtys: initQtys,
    addons: { priority: false, backside: false, slider: false },
    backsideType: null,
    backsideFont: 'Serif',
    backsideNames: [],
    backsideNameColors: [],
    logoFile: null,
    logoPreview: null,
    backsideLogoFile: null,
    backsideLogoPreview: null,
    openFaq: null,
    configImg: 0,
    scrolled: false,
    heroImg: 0,
    dragOver: false
  };

  /* ─── TIMER ─── */

  var TIMER_COOKIE = 'kdk_sale_end';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    days = days || 4;
    var d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/';
  }

  function initTimer() {
    var saved = getCookie(TIMER_COOKIE);
    var end;
    if (saved && Number(saved) > Date.now()) {
      end = Number(saved);
    } else {
      end = Date.now() + 72 * 3600000;
      setCookie(TIMER_COOKIE, end);
    }

    function update() {
      var diff = Math.max(0, end - Date.now());
      var totalSec = Math.floor(diff / 1000);
      var h = Math.floor(totalSec / 3600);
      var m = Math.floor((totalSec % 3600) / 60);
      var s = totalSec % 60;

      var els = document.querySelectorAll('[data-timer-h]');
      els.forEach(function (el) { el.textContent = String(h).padStart(2, '0'); });
      els = document.querySelectorAll('[data-timer-m]');
      els.forEach(function (el) { el.textContent = String(m).padStart(2, '0'); });
      els = document.querySelectorAll('[data-timer-s]');
      els.forEach(function (el) { el.textContent = String(s).padStart(2, '0'); });

      var timerTexts = document.querySelectorAll('[data-timer-text]');
      timerTexts.forEach(function (el) {
        el.textContent = h + 'h ' + m + 'm ' + s + 's';
      });
    }

    update();
    setInterval(update, 1000);
  }

  /* ─── HELPERS ─── */

  function distributeUnits(colors, units) {
    var result = {};
    var base = Math.floor(units / colors.length);
    var remainder = units % colors.length;
    colors.forEach(function (c, i) {
      result[c] = base + (i < remainder ? 1 : 0);
    });
    return result;
  }

  function scrollToEl(id) {
    var el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function $(sel, parent) {
    return (parent || document).querySelector(sel);
  }

  function $$(sel, parent) {
    return Array.from((parent || document).querySelectorAll(sel));
  }

  /* ─── RENDERING ─── */

  function getTier() { return TIERS[state.tierIdx]; }

  function getGrandTotal() {
    var tier = getTier();
    var base = tier.totalPrice || (tier.units * tier.perUnit);
    var priority = state.addons.priority ? ADDONS[0].price * tier.units : 0;
    var backside = state.addons.backside ? ADDONS[1].price * tier.units : 0;
    var slider = state.addons.slider ? ADDONS[2].price * tier.units : 0;
    return base + priority + backside + slider;
  }

  function getQtyAllocated() {
    return Object.values(state.colorQtys).reduce(function (s, v) { return s + v; }, 0);
  }

  function handleCheckout() {
    var tier = getTier();
    if (!tier.variantId) {
      alert('Unable to find a matching product variant. Please try a different pack size.');
      return;
    }

    var ctaBtn = $('.tl-summary-cta');
    if (ctaBtn) {
      ctaBtn.textContent = 'Adding to cart…';
      ctaBtn.classList.add('tl-btn--disabled');
    }

    var textProps = {};
    state.selectedColors.forEach(function (c) {
      if (state.colorQtys[c] > 0) textProps['Color: ' + c] = state.colorQtys[c] + ' units';
    });
    if (state.addons.backside) {
      textProps['Backside Engraving'] = state.backsideType || 'Yes';
      if (state.backsideType === 'names' && state.backsideNames.length > 0) {
        var grouped = {};
        state.backsideNames.forEach(function (n, i) {
          var c = state.backsideNameColors[i] || state.selectedColors[0] || 'Default';
          if (!grouped[c]) grouped[c] = [];
          grouped[c].push(n);
        });
        Object.keys(grouped).forEach(function (c) {
          textProps['Backside Names (' + c + ')'] = grouped[c].join(', ');
        });
        textProps['Backside Font'] = state.backsideFont;
      }
    }

    var addonItems = [];
    if (state.addons.priority && ADDON_DATA.priority && ADDON_DATA.priority.variant_id) {
      addonItems.push({ id: ADDON_DATA.priority.variant_id, quantity: tier.units });
    }
    if (state.addons.backside && ADDON_DATA.backside && ADDON_DATA.backside.variant_id) {
      var bsProps = {};
      if (state.backsideType) bsProps['Type'] = state.backsideType;
      if (state.backsideType === 'names' && state.backsideNames.length > 0) {
        var bsGrouped = {};
        state.backsideNames.forEach(function (n, i) {
          var c = state.backsideNameColors[i] || state.selectedColors[0] || 'Default';
          if (!bsGrouped[c]) bsGrouped[c] = [];
          bsGrouped[c].push(n);
        });
        Object.keys(bsGrouped).forEach(function (c) {
          bsProps['Names (' + c + ')'] = bsGrouped[c].join(', ');
        });
        bsProps['Font'] = state.backsideFont;
      }
      addonItems.push({ id: ADDON_DATA.backside.variant_id, quantity: tier.units, properties: bsProps });
    }
    if (state.addons.slider && ADDON_DATA.slider && ADDON_DATA.slider.variant_id) {
      addonItems.push({ id: ADDON_DATA.slider.variant_id, quantity: tier.units });
    }

    fetch('/cart/clear.js', { method: 'POST' })
    .then(function () {
      var formData = new FormData();
      formData.append('id', tier.variantId);
      formData.append('quantity', 1);
      Object.keys(textProps).forEach(function (key) {
        formData.append('properties[' + key + ']', textProps[key]);
      });
      if (state.logoFile) {
        formData.append('properties[artwork]', state.logoFile);
      }
      if (state.backsideLogoFile && state.backsideType === 'different') {
        formData.append('properties[backside_artwork]', state.backsideLogoFile);
      }
      return fetch('/cart/add.js', { method: 'POST', body: formData });
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart error: main product');
      return res.json();
    })
    .then(function () {
      if (addonItems.length === 0) return Promise.resolve();
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: addonItems })
      }).then(function (res) {
        if (!res.ok) throw new Error('Cart error: addons');
        return res.json();
      });
    })
    .then(function () {
      window.location.href = '/checkout';
    })
    .catch(function (err) {
      console.error('Checkout error:', err);
      if (ctaBtn) {
        ctaBtn.textContent = 'Proceed to Checkout — $' + Math.round(getGrandTotal()) + ' →';
        ctaBtn.classList.remove('tl-btn--disabled');
      }
      alert('Something went wrong adding to cart. Please try again.');
    });
  }

  function renderTiers() {
    var tier = getTier();
    $$('.tl-tier-card').forEach(function (card, i) {
      var isActive = i === state.tierIdx;
      card.classList.toggle('active', isActive);
      var check = card.querySelector('.tl-tier-check');
      if (check) check.style.display = isActive ? 'flex' : 'none';
      $$('.tl-tier-bullet', card).forEach(function (b) {
        b.style.color = isActive ? 'var(--tl-green)' : '';
      });
    });
  }

  function getColorObj(name) {
    return COLORS.find(function (c) { return c.name === name; }) || { name: name, hex: '#888888', light: false };
  }

  function renderColorSwatches() {
    var tier = getTier();
    var maxC = tier.maxColors;
    $$('.tl-color-swatch').forEach(function (swatch) {
      var name = swatch.dataset.color;
      var cObj = getColorObj(name);
      var active = state.selectedColors.indexOf(name) !== -1;
      var atMax = !active && state.selectedColors.length >= maxC;
      swatch.classList.toggle('at-max', atMax);
      var dot = swatch.querySelector('.tl-color-dot');
      if (dot) {
        dot.classList.toggle('active', active);
        dot.style.backgroundColor = cObj.hex;
        dot.classList.toggle('light', cObj.light);
      }
      var check = swatch.querySelector('.tl-color-check');
      if (check) {
        check.style.display = active ? 'flex' : 'none';
        var checkSpan = check.querySelector('span');
        if (checkSpan) checkSpan.style.color = cObj.light ? '#333' : '#fff';
      }
      var nameEl = swatch.querySelector('.tl-color-name');
      if (nameEl) nameEl.classList.toggle('active', active);
    });

    var statusEl = $('.tl-color-status');
    if (statusEl) {
      var alloc = getQtyAllocated();
      statusEl.textContent = state.selectedColors.length + ' of ' + (maxC >= 99 ? '∞' : maxC) + ' colors · ' + alloc + '/' + tier.units + ' units';
    }
  }

  function renderQtyAllocation() {
    var container = $('.tl-qty-rows');
    if (!container) return;
    var tier = getTier();
    var alloc = getQtyAllocated();
    var valid = alloc === tier.units;

    var headerEl = $('.tl-qty-header');
    if (headerEl) {
      headerEl.innerHTML = 'Quantity per Color' + (!valid ? ' <span class="tl-qty-warning"> — ' + alloc + '/' + tier.units + ' allocated</span>' : '');
    }

    container.innerHTML = '';
    state.selectedColors.forEach(function (cName) {
      var cObj = getColorObj(cName);
      var qty = state.colorQtys[cName] || 0;
      var row = document.createElement('div');
      row.className = 'tl-qty-row';
      row.innerHTML =
        '<div class="tl-qty-color-dot" style="background:' + cObj.hex + (cObj.light ? ';border:1px solid var(--tl-gray-300)' : '') + '"></div>' +
        '<span class="tl-qty-color-name">' + cName + '</span>' +
        '<div class="tl-qty-controls">' +
        '<button class="tl-qty-btn" data-color="' + cName + '" data-delta="-1">−</button>' +
        '<span class="tl-qty-value">' + qty + '</span>' +
        '<button class="tl-qty-btn" data-color="' + cName + '" data-delta="1">+</button>' +
        '</div>';
      container.appendChild(row);
    });
  }

  function renderAddons() {
    $$('.tl-addon-card').forEach(function (card) {
      var id = card.dataset.addon;
      var on = state.addons[id];
      card.classList.toggle('active', on);
      var toggle = card.querySelector('.tl-toggle');
      if (toggle) toggle.classList.toggle('active', on);
      var label = card.querySelector('.tl-toggle-label');
      if (label) {
        label.classList.toggle('active', on);
        label.textContent = on ? 'Added' : 'Add to order';
      }
      var priceEl = card.querySelector('.tl-addon-price');
      if (priceEl) priceEl.classList.toggle('active', on);

      var totalEl = card.querySelector('.tl-addon-price-total');
      if (totalEl) {
        var addon = ADDONS.find(function (a) { return a.id === id; });
        totalEl.textContent = '$' + (addon.price * getTier().units) + ' for ' + getTier().units + ' units';
      }
    });

    var backsidePanel = $('.tl-backside-panel');
    if (backsidePanel) {
      backsidePanel.style.display = state.addons.backside ? 'block' : 'none';
    }
  }

  function renderBacksideOptions() {
    $$('.tl-backside-option').forEach(function (opt) {
      opt.classList.toggle('active', opt.dataset.type === state.backsideType);
      var radio = opt.querySelector('.tl-radio');
      if (radio) radio.classList.toggle('active', opt.dataset.type === state.backsideType);
      var dot = opt.querySelector('.tl-radio-dot');
      if (dot) dot.style.display = opt.dataset.type === state.backsideType ? 'block' : 'none';
    });

    var sameInfo = $('.tl-backside-same-info');
    if (sameInfo) sameInfo.style.display = state.backsideType === 'same' ? 'block' : 'none';

    var diffUpload = $('.tl-backside-diff-upload');
    if (diffUpload) diffUpload.style.display = state.backsideType === 'different' ? 'block' : 'none';

    var namesFlow = $('.tl-names-flow');
    if (namesFlow) namesFlow.style.display = state.backsideType === 'names' ? 'block' : 'none';

    renderBacksideNames();
  }

  function countNamesForColor(color) {
    var count = 0;
    state.backsideNameColors.forEach(function (c) { if (c === color) count++; });
    return count;
  }

  function renderBacksideNames() {
    var container = $('.tl-names-list');
    if (!container) return;
    var tier = getTier();
    var font = BACKSIDE_FONTS.find(function (f) { return f.name === state.backsideFont; });

    container.innerHTML = '';

    state.selectedColors.forEach(function (color) {
      var cObj = getColorObj(color);
      var maxForColor = state.colorQtys[color] || 0;
      if (maxForColor <= 0) return;
      var colorCount = countNamesForColor(color);

      var section = document.createElement('div');
      section.className = 'tl-names-color-section';

      section.innerHTML =
        '<div class="tl-names-color-header">' +
          '<span class="tl-names-color-dot" style="background:' + cObj.hex + ';' + (cObj.light ? 'border:1px solid var(--tl-gray-300)' : '') + '"></span>' +
          '<span class="tl-names-color-name">' + color + '</span>' +
          '<span class="tl-names-color-count">' + colorCount + '/' + maxForColor + '</span>' +
        '</div>';

      var chips = document.createElement('div');
      chips.className = 'tl-names-chips';
      state.backsideNames.forEach(function (name, i) {
        if (state.backsideNameColors[i] !== color) return;
        var tag = document.createElement('div');
        tag.className = 'tl-name-tag';
        tag.style.fontFamily = font ? font.style : 'serif';
        tag.style.borderLeftColor = cObj.hex;
        tag.innerHTML =
          '<span class="tl-name-tag-text">' + name + '</span>' +
          '<span class="tl-name-tag-remove" data-idx="' + i + '">✕</span>';
        chips.appendChild(tag);
      });
      section.appendChild(chips);

      if (colorCount < maxForColor) {
        var inputRow = document.createElement('div');
        inputRow.className = 'tl-names-input-row';
        inputRow.innerHTML =
          '<input type="text" class="tl-name-color-input" data-color="' + color + '" placeholder="Name for ' + color + ' tumbler…" />' +
          '<button class="tl-add-color-name-btn" data-color="' + color + '">+ Add</button>';
        section.appendChild(inputRow);
      }

      container.appendChild(section);
    });

    var status = $('.tl-names-status');
    if (status) {
      if (state.backsideNames.length < tier.units) {
        status.style.color = 'var(--tl-amber)';
        status.textContent = (tier.units - state.backsideNames.length) + ' more name' + (tier.units - state.backsideNames.length !== 1 ? 's' : '') + ' needed to fill your order of ' + tier.units + ' units';
      } else {
        status.style.color = 'var(--tl-green)';
        status.textContent = '✓ All ' + tier.units + ' names entered — you\'re all set!';
      }
      status.style.display = state.backsideNames.length > 0 ? 'block' : 'none';
    }

    $$('.tl-font-option').forEach(function (opt) {
      opt.classList.toggle('active', opt.dataset.font === state.backsideFont);
    });

    var nameCount = $('.tl-names-count');
    if (nameCount) nameCount.textContent = state.backsideNames.length + ' of ' + tier.units;
  }

  function renderLogoUpload() {
    var zone = $('.tl-upload-zone');
    var preview = $('.tl-upload-preview');
    if (!zone || !preview) return;

    if (state.logoPreview) {
      zone.style.display = 'none';
      preview.style.display = 'flex';
      var img = preview.querySelector('img');
      if (img) img.src = state.logoPreview;
      var nameEl = preview.querySelector('.tl-upload-filename');
      if (nameEl && state.logoFile) nameEl.textContent = state.logoFile.name;
    } else {
      zone.style.display = 'block';
      preview.style.display = 'none';
    }
  }

  function renderBacksideLogoUpload() {
    var zone = $('.tl-backside-upload-zone');
    var preview = $('.tl-backside-upload-preview');
    if (!zone || !preview) return;

    if (state.backsideLogoPreview) {
      zone.style.display = 'none';
      preview.style.display = 'flex';
      var img = preview.querySelector('img');
      if (img) img.src = state.backsideLogoPreview;
      var nameEl = preview.querySelector('.tl-backside-upload-filename');
      if (nameEl && state.backsideLogoFile) nameEl.textContent = state.backsideLogoFile.name;
    } else {
      zone.style.display = 'block';
      preview.style.display = 'none';
    }
  }

  function renderOrderSummary() {
    var tier = getTier();
    var grand = getGrandTotal();
    var alloc = getQtyAllocated();
    var valid = alloc === tier.units;

    var summary = $('.tl-order-summary');
    if (!summary) return;
    summary.classList.toggle('popular', !!tier.popular);

    var titleEl = $('.tl-summary-title');
    if (titleEl) titleEl.textContent = tier.name + ' — ' + tier.units + ' × 20oz Tumbler';

    var colorsEl = $('.tl-summary-colors');
    if (colorsEl) {
      colorsEl.innerHTML = '';
      state.selectedColors.forEach(function (c) {
        var cObj = getColorObj(c);
        var chip = document.createElement('div');
        chip.className = 'tl-summary-color-chip';
        chip.innerHTML =
          '<div class="tl-summary-color-dot" style="background:' + cObj.hex + (cObj.light ? ';border:1px solid var(--tl-gray-300)' : '') + '"></div>' +
          '<span style="font-size:10px;font-weight:600;color:var(--tl-navy)">' + c + '</span>' +
          '<span style="font-size:9px;color:var(--tl-gray-400)">×' + (state.colorQtys[c] || 0) + '</span>';
        colorsEl.appendChild(chip);
      });
    }

    var logoStatus = $('.tl-summary-logo-status');
    if (logoStatus) {
      logoStatus.style.display = state.logoFile ? 'block' : 'none';
      if (state.logoFile) logoStatus.textContent = '✓ Logo: ' + state.logoFile.name;
    }

    var totalEl = $('.tl-summary-grand-total');
    if (totalEl) totalEl.textContent = '$' + Math.round(grand);

    var perEl = $('.tl-summary-per-unit');
    if (perEl) perEl.textContent = '$' + tier.perUnit + '/unit base';

    var baseLine = $('.tl-summary-base-line');
    if (baseLine) {
      var baseTotal = tier.totalPrice || (tier.units * tier.perUnit);
      baseLine.innerHTML = '<span>' + tier.units + ' × 20oz Tumbler @ $' + tier.perUnit.toFixed(2) + '/ea</span><span style="font-weight:600">$' + baseTotal.toFixed(2) + '</span>';
    }

    var priorityLine = $('.tl-summary-priority-line');
    if (priorityLine) {
      priorityLine.style.display = state.addons.priority ? 'flex' : 'none';
      if (state.addons.priority) {
        priorityLine.innerHTML = '<span>⚡ Priority Processing (' + tier.units + ' × $4)</span><span style="font-weight:600">+$' + (ADDONS[0].price * tier.units).toFixed(2) + '</span>';
      }
    }

    var backsideLine = $('.tl-summary-backside-line');
    if (backsideLine) {
      backsideLine.style.display = state.addons.backside ? 'block' : 'none';
      if (state.addons.backside) {
        var detail = '';
        if (state.backsideType === 'same') detail = 'Same design as front';
        else if (state.backsideType === 'different') detail = 'Different design / logo' + (state.backsideLogoFile ? ' (' + state.backsideLogoFile.name + ')' : '');
        else if (state.backsideType === 'names') detail = 'Personalized names (' + state.backsideNames.length + '/' + tier.units + ') · ' + state.backsideFont + ' font';
        backsideLine.innerHTML =
          '<div class="tl-summary-line"><span>🔄 Backside Engraving (' + tier.units + ' × $4)</span><span style="font-weight:600">+$' + (ADDONS[1].price * tier.units).toFixed(2) + '</span></div>' +
          (state.backsideType ? '<div style="font-size:10px;color:var(--tl-gray-400);padding-left:22px;margin-top:2px">' + detail + '</div>' : '');
      }
    }

    var sliderLine = $('.tl-summary-slider-line');
    if (sliderLine) {
      sliderLine.style.display = state.addons.slider ? 'flex' : 'none';
      if (state.addons.slider) {
        sliderLine.innerHTML = '<span>🔒 Slider Lid Upgrade (' + tier.units + ' × $2)</span><span style="font-weight:600">+$' + (ADDONS[2].price * tier.units).toFixed(2) + '</span>';
      }
    }

    var shippingLine = $('.tl-summary-shipping-line');
    if (shippingLine) {
      shippingLine.style.display = tier.freeShipping ? 'flex' : 'none';
    }

    var featuresEl = $('.tl-summary-features');
    if (featuresEl) {
      featuresEl.innerHTML = '';
      tier.features.forEach(function (f) {
        var div = document.createElement('div');
        div.className = 'tl-flex tl-items-center tl-gap-2';
        div.style.marginBottom = '4px';
        div.innerHTML = '<span style="color:var(--tl-green);font-size:11px;flex-shrink:0">✓</span><span style="font-size:12px;color:var(--tl-gray-800)">' + f + '</span>';
        featuresEl.appendChild(div);
      });
    }

    var savingsEl = $('.tl-summary-savings-amount');
    if (savingsEl) savingsEl.textContent = 'You save $' + Math.round((20 - tier.perUnit) * tier.units);

    var ctaBtn = $('.tl-summary-cta');
    if (ctaBtn) {
      ctaBtn.classList.toggle('tl-btn--disabled', !valid);
      if (valid) {
        ctaBtn.textContent = 'Proceed to Checkout — $' + Math.round(grand) + ' →';
        ctaBtn.dataset.ready = 'true';
      } else {
        ctaBtn.textContent = 'Allocate all ' + tier.units + ' units to continue';
        ctaBtn.dataset.ready = 'false';
      }
    }

    renderBottomBar();
  }

  function renderBottomBar() {
    var bar = $('.tl-bottom-bar');
    if (!bar) return;
    bar.classList.toggle('visible', state.scrolled);

    var tier = getTier();
    var grand = getGrandTotal();

    var info = bar.querySelector('.tl-bottom-bar-info');
    if (info) info.textContent = tier.units + '× 20oz Tumbler';

    var colorsDiv = bar.querySelector('.tl-bottom-bar-colors');
    if (colorsDiv) {
      colorsDiv.innerHTML = '';
      state.selectedColors.forEach(function (c) {
        var col = getColorObj(c);
        var dot = document.createElement('div');
        dot.className = 'tl-bottom-bar-color-dot';
        dot.style.background = col.hex;
        dot.title = c + ': ' + (state.colorQtys[c] || 0);
        colorsDiv.appendChild(dot);
      });
    }

    var totalEl = bar.querySelector('.tl-bottom-bar-total');
    if (totalEl) totalEl.textContent = '$' + Math.round(grand);

    var perEl = bar.querySelector('.tl-bottom-bar-perunit');
    if (perEl) perEl.textContent = '$' + tier.perUnit + '/ea';
  }

  function renderConfigGallery() {
    var thumbs = $$('.tl-config-thumb');
    var mainImgs = $$('.tl-config-main-img');
    var imgSrc = PRODUCT_IMAGES.length > 0
      ? (PRODUCT_IMAGES[state.configImg] || PRODUCT_IMAGES[0])
      : (thumbs[state.configImg] ? thumbs[state.configImg].src : '');

    mainImgs.forEach(function (img) { if (imgSrc) img.src = imgSrc; });
    thumbs.forEach(function (thumb, i) {
      var idx = Number(thumb.dataset.imgIdx);
      thumb.classList.toggle('active', idx === state.configImg);
      thumb.style.borderColor = idx === state.configImg ? 'var(--tl-amber)' : 'var(--tl-gray-200)';
    });
  }

  function renderHeroGallery() {
    var mainImg = $('.tl-hero-img-main');
    var thumbs = $$('.tl-hero-thumb');
    if (mainImg && PRODUCT_IMAGES.length > 0) {
      mainImg.src = PRODUCT_IMAGES[state.heroImg] || PRODUCT_IMAGES[0];
    } else if (mainImg && thumbs.length > 0) {
      var src = thumbs[state.heroImg] ? thumbs[state.heroImg].querySelector('img').src : '';
      mainImg.src = src;
    }
    thumbs.forEach(function (t, i) {
      t.classList.toggle('active', i === state.heroImg);
    });
  }

  function renderEnterprise() {
    var callout = $('.tl-enterprise-callout');
    if (callout) {
      var tier = getTier();
      callout.style.display = tier.units >= 96 ? 'block' : 'none';
    }
  }

  function renderColorPreview() {
    var preview = $('.tl-color-preview');
    if (!preview) return;
    var last = state.selectedColors[state.selectedColors.length - 1];
    var imgUrl = last ? COLOR_IMAGES[last] : null;
    if (!imgUrl && PRODUCT_DATA.all_images && PRODUCT_DATA.all_images.length) {
      imgUrl = PRODUCT_DATA.all_images[0].src;
    }
    if (imgUrl) {
      preview.style.display = '';
      var img = preview.querySelector('.tl-color-preview-img');
      var label = preview.querySelector('.tl-color-preview-label');
      if (img) img.src = imgUrl;
      if (img) img.alt = last || '';
      if (label) label.textContent = last || 'Product Preview';
    } else {
      preview.style.display = 'none';
    }
  }

  function openLightbox(src, alt) {
    var lb = $('.tl-lightbox');
    if (!lb) return;
    var body = lb.querySelector('.tl-lightbox-body');
    var reviewPanel = lb.querySelector('.tl-lightbox-review');
    if (body) body.style.display = '';
    if (reviewPanel) reviewPanel.style.display = 'none';
    lb.style.display = 'flex';
    var img = lb.querySelector('.tl-lightbox-img');
    if (img) { img.src = src; img.alt = alt || ''; }
    document.body.style.overflow = 'hidden';
  }

  function openReviewLightbox(review) {
    var lb = $('.tl-lightbox');
    if (!lb) return;
    var body = lb.querySelector('.tl-lightbox-body');
    var reviewPanel = lb.querySelector('.tl-lightbox-review');
    if (body) body.style.display = 'none';
    if (reviewPanel) {
      reviewPanel.style.display = '';
      var img = reviewPanel.querySelector('.tl-lightbox-review-img');
      if (img) { img.src = review.img; img.alt = review.name; }
      var nameEl = reviewPanel.querySelector('.tl-lightbox-review-name');
      if (nameEl) nameEl.textContent = review.name;
      var textEl = reviewPanel.querySelector('.tl-lightbox-review-text');
      if (textEl) textEl.textContent = '"' + review.text + '"';
    }
    lb.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    var lb = $('.tl-lightbox');
    if (!lb) return;
    lb.style.display = 'none';
    document.body.style.overflow = '';
  }

  /* ─── REVIEW SECTIONS ─── */

  function buildReviewCard(r, showCat) {
    var card = document.createElement('div');
    card.className = 'tl-review-card';
    card.style.cursor = 'pointer';
    var html = '<div class="tl-review-photo"><img src="' + r.img + '" alt="' + r.name + ' custom tumbler" loading="lazy" /></div>';
    html += '<div class="tl-review-body">';
    if (showCat) html += '<span class="tl-review-cat-badge">' + r.cat.replace(/&/g, '&amp;') + '</span>';
    html += '<span class="tl-stars" style="font-size:12px">★★★★★</span>';
    html += '<p class="tl-review-text">"' + r.text + '"</p>';
    html += '<div><span style="font-weight:700;font-size:13px;color:var(--tl-navy)">' + r.name + '</span>';
    html += '<span style="font-size:11px;color:var(--tl-gray-400)"> · Verified</span></div>';
    html += '</div>';
    card.innerHTML = html;
    var img = card.querySelector('img');
    if (img) {
      img.addEventListener('error', function () { img.parentElement.style.background = 'linear-gradient(135deg, var(--tl-navy), #2d3a4d)'; img.style.display = 'none'; });
    }
    card.addEventListener('click', function () { openReviewLightbox(r); });
    return card;
  }

  function buildTestimonialCard(r) {
    var card = document.createElement('div');
    card.className = 'tl-testimonial-card';
    card.style.cursor = 'pointer';
    var html = '<div class="tl-testimonial-img"><img src="' + r.img + '" alt="' + r.name + '" loading="lazy" /></div>';
    html += '<div class="tl-testimonial-body">';
    html += '<div class="tl-flex tl-items-center tl-gap-2" style="margin-bottom:8px">';
    html += '<span class="tl-stars" style="font-size:11px">★★★★★</span>';
    html += '<span class="tl-testimonial-context">Repeat buyer</span>';
    html += '</div>';
    html += '<p class="tl-testimonial-text">"' + r.text + '"</p>';
    html += '<div class="tl-testimonial-author">';
    html += '<span class="tl-testimonial-name">' + r.name + '</span>';
    html += '<span class="tl-testimonial-role"> · Verified</span>';
    html += '</div></div>';
    card.innerHTML = html;
    var img = card.querySelector('img');
    if (img) {
      img.addEventListener('error', function () { img.parentElement.style.background = 'linear-gradient(135deg, var(--tl-navy), #2d3a4d)'; img.style.display = 'none'; });
    }
    card.addEventListener('click', function () { openReviewLightbox(r); });
    return card;
  }

  function renderReorderSection() {
    var strip = document.getElementById('tl-reorder-strip');
    if (!strip) return;
    strip.innerHTML = '';
    var reorderReviews = ALL_REVIEWS.filter(function (r) { return r.cat === 'Repeat Business & Volume Orders'; });
    reorderReviews.forEach(function (r) { strip.appendChild(buildTestimonialCard(r)); });
  }

  var currentReviewFilter = 'All';

  function renderReviewFilters() {
    var container = document.getElementById('tl-review-filters');
    if (!container) return;
    container.innerHTML = '';

    // Desktop pills
    var allPill = document.createElement('button');
    allPill.className = 'tl-filter-pill' + (currentReviewFilter === 'All' ? ' active' : '');
    allPill.innerHTML = 'All <span class="tl-filter-count">(' + ALL_REVIEWS.length + ')</span>';
    allPill.addEventListener('click', function () { currentReviewFilter = 'All'; renderReviewFilters(); renderReviewStrip(); });
    container.appendChild(allPill);
    REVIEW_CATEGORIES.forEach(function (cat) {
      var pill = document.createElement('button');
      pill.className = 'tl-filter-pill' + (currentReviewFilter === cat ? ' active' : '');
      pill.innerHTML = cat + ' <span class="tl-filter-count">(' + catCounts[cat] + ')</span>';
      pill.addEventListener('click', function () { currentReviewFilter = cat; renderReviewFilters(); renderReviewStrip(); });
      container.appendChild(pill);
    });

    // Mobile dropdown
    var sel = document.createElement('select');
    sel.className = 'tl-filter-select';
    var allOpt = document.createElement('option');
    allOpt.value = 'All';
    allOpt.textContent = 'All Reviews (' + ALL_REVIEWS.length + ')';
    if (currentReviewFilter === 'All') allOpt.selected = true;
    sel.appendChild(allOpt);
    REVIEW_CATEGORIES.forEach(function (cat) {
      var opt = document.createElement('option');
      opt.value = cat;
      opt.textContent = cat + ' (' + catCounts[cat] + ')';
      if (currentReviewFilter === cat) opt.selected = true;
      sel.appendChild(opt);
    });
    sel.addEventListener('change', function () { currentReviewFilter = sel.value; renderReviewFilters(); renderReviewStrip(); });
    container.appendChild(sel);
  }

  function renderReviewStrip() {
    var strip = document.getElementById('tl-reviews-strip');
    if (!strip) return;
    strip.innerHTML = '';
    var filtered = currentReviewFilter === 'All' ? ALL_REVIEWS : ALL_REVIEWS.filter(function (r) { return r.cat === currentReviewFilter; });
    var showCat = currentReviewFilter === 'All';
    filtered.forEach(function (r) { strip.appendChild(buildReviewCard(r, showCat)); });
    // duplicate cards for infinite scroll effect
    filtered.forEach(function (r) { strip.appendChild(buildReviewCard(r, showCat)); });
    var wrap = strip.parentElement;
    if (wrap) wrap.scrollLeft = 0;
  }

  function initInfiniteScroll(wrapSelector) {
    var wrap = document.querySelector(wrapSelector);
    if (!wrap) return;
    wrap.addEventListener('scroll', function () {
      var strip = wrap.firstElementChild;
      if (!strip) return;
      var halfWidth = strip.scrollWidth / 2;
      if (wrap.scrollLeft >= halfWidth) {
        wrap.scrollLeft -= halfWidth;
      } else if (wrap.scrollLeft <= 0) {
        wrap.scrollLeft += halfWidth;
      }
    });
  }

  function renderAll() {
    renderTiers();
    renderColorSwatches();
    renderColorPreview();
    renderQtyAllocation();
    renderAddons();
    renderBacksideOptions();
    renderLogoUpload();
    renderBacksideLogoUpload();
    renderOrderSummary();
    renderConfigGallery();
    renderHeroGallery();
    renderEnterprise();
  }

  /* ─── EVENT HANDLERS ─── */

  function selectTier(i) {
    if (i < 0 || i >= TIERS.length) return;
    state.tierIdx = i;
    var t = TIERS[i];
    state.selectedColors = state.selectedColors.slice(0, t.maxColors);
    if (state.selectedColors.length === 0) state.selectedColors = [COLORS[0] ? COLORS[0].name : 'Black'];
    state.colorQtys = distributeUnits(state.selectedColors, t.units);
    renderAll();
  }

  function toggleColor(name) {
    var tier = getTier();
    var idx = state.selectedColors.indexOf(name);
    if (idx !== -1) {
      if (state.selectedColors.length <= 1) return;
      state.selectedColors.splice(idx, 1);
    } else {
      if (state.selectedColors.length >= tier.maxColors) return;
      state.selectedColors.push(name);
    }
    state.colorQtys = distributeUnits(state.selectedColors, tier.units);
    renderAll();
  }

  function adjustQty(color, delta) {
    var tier = getTier();
    var current = Object.assign({}, state.colorQtys);
    var newVal = Math.max(0, (current[color] || 0) + delta);
    var others = Object.entries(current).filter(function (e) { return e[0] !== color; });
    var othersTotal = others.reduce(function (s, e) { return s + e[1]; }, 0);

    if (newVal + othersTotal > tier.units) {
      var excess = (newVal + othersTotal) - tier.units;
      var remaining = excess;
      for (var i = others.length - 1; i >= 0 && remaining > 0; i--) {
        var reduce = Math.min(others[i][1], remaining);
        current[others[i][0]] -= reduce;
        remaining -= reduce;
      }
    }
    current[color] = Math.min(newVal, tier.units);
    var total = Object.values(current).reduce(function (s, v) { return s + v; }, 0);
    if (total < tier.units && others.length > 0) {
      current[others[0][0]] += tier.units - total;
    }
    state.colorQtys = current;
    renderAll();
  }

  function handleLogoFile(file) {
    if (!file) return;
    state.logoFile = file;
    var reader = new FileReader();
    reader.onload = function (e) {
      state.logoPreview = e.target.result;
      renderAll();
    };
    reader.readAsDataURL(file);
  }

  function handleBacksideLogoFile(file) {
    if (!file) return;
    state.backsideLogoFile = file;
    var reader = new FileReader();
    reader.onload = function (e) {
      state.backsideLogoPreview = e.target.result;
      renderAll();
    };
    reader.readAsDataURL(file);
  }

  function downloadNameTemplate(units) {
    var csv = 'Name,Color\n';
    state.selectedColors.forEach(function (c) {
      var qty = state.colorQtys[c] || 0;
      for (var i = 1; i <= qty; i++) csv += ',' + c + '\n';
    });
    var blob = new Blob([csv], { type: 'text/csv' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = 'tumbler-names-template.csv';
    a.click();
    URL.revokeObjectURL(url);
  }

  function parseNamesCsv(file) {
    return new Promise(function (resolve) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var lines = e.target.result.split('\n').map(function (l) { return l.trim(); }).filter(Boolean);
        if (lines.length > 0 && lines[0].toLowerCase().indexOf('name') !== -1) lines.shift();
        var entries = [];
        lines.forEach(function (line) {
          var parts = line.split(',');
          var name = (parts[0] || '').trim();
          var colorRaw = (parts[1] || '').trim();
          if (!name) return;
          var matched = state.selectedColors.find(function (c) {
            return c.toLowerCase() === colorRaw.toLowerCase();
          });
          entries.push({ name: name, color: matched || state.selectedColors[0] });
        });
        resolve(entries);
      };
      reader.readAsText(file);
    });
  }

  /* ─── INIT ─── */

  function init() {
    initTimer();

    // Hide theme header/footer/shipping bar so only the landing page shows
    ['#shopify-section-header', '#shopify-section-footer',
     '#shopify-section-shipping-bar', '#shopify-section-shipping_bar',
     '#shopify-section-announcement-bar', '#shopify-section-cart-drawer',
     '.mega-menu-container', '.site-overlay'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) el.style.display = 'none';
    });
    document.querySelectorAll('.shopify-section-group-header-group, .shopify-section-group-footer-group').forEach(function (el) {
      el.style.display = 'none';
    });

    var swatchContainer = $('.tl-color-swatches');
    if (swatchContainer) {
      swatchContainer.addEventListener('mouseover', function (e) {
        var sw = e.target.closest('.tl-color-swatch');
        if (!sw) return;
        var name = sw.dataset.color;
        var imgUrl = COLOR_IMAGES[name];
        if (!imgUrl && PRODUCT_DATA.all_images && PRODUCT_DATA.all_images.length) {
          imgUrl = PRODUCT_DATA.all_images[0].src;
        }
        var preview = $('.tl-color-preview');
        if (preview && imgUrl) {
          preview.style.display = '';
          var img = preview.querySelector('.tl-color-preview-img');
          var label = preview.querySelector('.tl-color-preview-label');
          if (img) { img.src = imgUrl; img.alt = name; }
          if (label) label.textContent = name;
        }
      });
      swatchContainer.addEventListener('mouseout', function (e) {
        if (e.relatedTarget && swatchContainer.contains(e.relatedTarget)) return;
        renderColorPreview();
      });
    }

    window.addEventListener('scroll', function () {
      state.scrolled = window.scrollY > 50;
      renderBottomBar();
      var header = $('.tl-sticky-header');
      if (header) header.classList.toggle('scrolled', state.scrolled);
    });

    document.addEventListener('click', function (e) {
      var target = e.target;

      // Checkout CTA
      var cta = target.closest('.tl-summary-cta');
      if (cta && cta.dataset.ready === 'true') {
        e.preventDefault();
        handleCheckout();
        return;
      }

      // Scroll-to buttons
      if (target.closest('[data-scroll-to]')) {
        e.preventDefault();
        scrollToEl(target.closest('[data-scroll-to]').dataset.scrollTo);
        return;
      }

      // Tier selection
      var tierCard = target.closest('.tl-tier-card');
      if (tierCard) {
        selectTier(Number(tierCard.dataset.tier));
        return;
      }

      // Color swatches
      var swatch = target.closest('.tl-color-swatch');
      if (swatch && !swatch.classList.contains('at-max')) {
        toggleColor(swatch.dataset.color);
        return;
      }

      // Color preview -> open lightbox
      if (target.closest('.tl-color-preview')) {
        var pImg = $('.tl-color-preview-img');
        if (pImg && pImg.src) openLightbox(pImg.src, pImg.alt);
        return;
      }

      // Lightbox close
      if (target.closest('.tl-lightbox-close') || target.closest('.tl-lightbox-backdrop')) {
        closeLightbox();
        return;
      }

      // Qty buttons
      var qtyBtn = target.closest('.tl-qty-btn');
      if (qtyBtn) {
        adjustQty(qtyBtn.dataset.color, Number(qtyBtn.dataset.delta));
        return;
      }

      // Addon toggles
      var addonHeader = target.closest('.tl-addon-header');
      if (addonHeader) {
        var card = addonHeader.closest('.tl-addon-card');
        var id = card.dataset.addon;
        state.addons[id] = !state.addons[id];
        if (id === 'backside' && !state.addons[id]) {
          state.backsideType = null;
          state.backsideNames = [];
          state.backsideNameColors = [];
        }
        renderAll();
        return;
      }

      // Backside type
      var bsOpt = target.closest('.tl-backside-option');
      if (bsOpt) {
        state.backsideType = bsOpt.dataset.type;
        if (bsOpt.dataset.type !== 'names') { state.backsideNames = []; state.backsideNameColors = []; }
        renderBacksideOptions();
        renderOrderSummary();
        return;
      }

      // Font options
      var fontOpt = target.closest('.tl-font-option');
      if (fontOpt) {
        state.backsideFont = fontOpt.dataset.font;
        renderBacksideNames();
        return;
      }

      // Name removal
      var nameRemove = target.closest('.tl-name-tag-remove');
      if (nameRemove) {
        var rmIdx = Number(nameRemove.dataset.idx);
        state.backsideNames.splice(rmIdx, 1);
        state.backsideNameColors.splice(rmIdx, 1);
        renderBacksideNames();
        renderOrderSummary();
        return;
      }

      // FAQ items
      var faqItem = target.closest('.tl-faq-item');
      if (faqItem) {
        var idx = Number(faqItem.dataset.faq);
        state.openFaq = state.openFaq === idx ? null : idx;
        $$('.tl-faq-item').forEach(function (item, i) {
          item.classList.toggle('open', i === state.openFaq);
        });
        return;
      }

      // Hero thumbnails
      var heroThumb = target.closest('.tl-hero-thumb');
      if (heroThumb) {
        state.heroImg = Number(heroThumb.dataset.idx);
        renderHeroGallery();
        return;
      }

      // Config thumbnails
      var configThumb = target.closest('.tl-config-thumb');
      if (configThumb) {
        state.configImg = Number(configThumb.dataset.imgIdx);
        renderConfigGallery();
        return;
      }

      // Config nav
      if (target.closest('.tl-config-nav-btn--prev')) {
        var imgCount = PRODUCT_IMAGES.length || 1;
        state.configImg = (state.configImg + imgCount - 1) % imgCount;
        renderConfigGallery();
        return;
      }
      if (target.closest('.tl-config-nav-btn--next')) {
        var imgCount2 = PRODUCT_IMAGES.length || 1;
        state.configImg = (state.configImg + 1) % imgCount2;
        renderConfigGallery();
        return;
      }

      // Logo upload zone
      var uploadZone = target.closest('.tl-upload-zone');
      if (uploadZone) {
        var fileInput = document.getElementById('tl-logo-input');
        if (fileInput) fileInput.click();
        return;
      }

      // Remove logo
      if (target.closest('.tl-remove-logo')) {
        state.logoFile = null;
        state.logoPreview = null;
        renderAll();
        return;
      }

      // Backside upload zone
      var bsUploadZone = target.closest('.tl-backside-upload-zone');
      if (bsUploadZone) {
        var bsInput = document.getElementById('tl-backside-logo-input');
        if (bsInput) bsInput.click();
        return;
      }

      // Remove backside logo
      if (target.closest('.tl-remove-backside-logo')) {
        state.backsideLogoFile = null;
        state.backsideLogoPreview = null;
        renderAll();
        return;
      }

      // Download CSV template
      if (target.closest('.tl-download-csv')) {
        downloadNameTemplate(getTier().units);
        return;
      }

      // Upload CSV
      if (target.closest('.tl-upload-csv')) {
        var csvInput = document.getElementById('tl-names-csv-input');
        if (csvInput) csvInput.click();
        return;
      }

      // Add name button (per-color)
      var addColorBtn = target.closest('.tl-add-color-name-btn');
      if (addColorBtn) {
        var addColor = addColorBtn.dataset.color;
        var colorInput = addColorBtn.parentElement.querySelector('.tl-name-color-input');
        if (colorInput && colorInput.value.trim()) {
          var maxForC = state.colorQtys[addColor] || 0;
          if (countNamesForColor(addColor) < maxForC && state.backsideNames.length < getTier().units) {
            state.backsideNames.push(colorInput.value.trim());
            state.backsideNameColors.push(addColor);
            colorInput.value = '';
            renderBacksideNames();
            renderOrderSummary();
            var newInput = document.querySelector('.tl-name-color-input[data-color="' + addColor + '"]');
            if (newInput) newInput.focus();
          }
        }
        return;
      }
    });

    // File inputs — create programmatically to avoid theme content processing issues
    var logoInput = document.getElementById('tl-logo-input');
    if (!logoInput) {
      logoInput = document.createElement('input');
      logoInput.type = 'file';
      logoInput.id = 'tl-logo-input';
      logoInput.accept = '.png,.jpg,.jpeg,.svg,.pdf,.ai,.eps';
      logoInput.style.display = 'none';
      document.body.appendChild(logoInput);
    }
    logoInput.addEventListener('change', function (e) {
      handleLogoFile(e.target.files[0]);
      e.target.value = '';
    });

    var bsLogoInput = document.getElementById('tl-backside-logo-input');
    if (!bsLogoInput) {
      bsLogoInput = document.createElement('input');
      bsLogoInput.type = 'file';
      bsLogoInput.id = 'tl-backside-logo-input';
      bsLogoInput.accept = '.png,.jpg,.jpeg,.svg,.pdf,.ai,.eps';
      bsLogoInput.style.display = 'none';
      document.body.appendChild(bsLogoInput);
    }
    bsLogoInput.addEventListener('change', function (e) {
      handleBacksideLogoFile(e.target.files[0]);
      e.target.value = '';
    });

    var csvInput = document.getElementById('tl-names-csv-input');
    if (csvInput) {
      csvInput.addEventListener('change', function (e) {
        if (e.target.files[0]) {
          parseNamesCsv(e.target.files[0]).then(function (parsed) {
            state.backsideNames = [];
            state.backsideNameColors = [];
            parsed.forEach(function (entry) {
              if (state.backsideNames.length >= getTier().units) return;
              var color = entry.color || state.selectedColors[0];
              var maxForC = state.colorQtys[color] || 0;
              if (countNamesForColor(color) < maxForC) {
                state.backsideNames.push(entry.name);
                state.backsideNameColors.push(color);
              }
            });
            renderBacksideNames();
            renderOrderSummary();
          });
        }
      });
    }

    // Name input enter key (delegated for per-color inputs)
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.classList.contains('tl-name-color-input')) {
        var inputColor = e.target.dataset.color;
        var val = e.target.value.trim();
        if (val && inputColor) {
          var maxForC = state.colorQtys[inputColor] || 0;
          if (countNamesForColor(inputColor) < maxForC && state.backsideNames.length < getTier().units) {
            state.backsideNames.push(val);
            state.backsideNameColors.push(inputColor);
            e.target.value = '';
            renderBacksideNames();
            renderOrderSummary();
            var newInput = document.querySelector('.tl-name-color-input[data-color="' + inputColor + '"]');
            if (newInput) newInput.focus();
          }
        }
      }
    });

    // Drag and drop for logo
    var uploadZone = $('.tl-upload-zone');
    if (uploadZone) {
      uploadZone.addEventListener('dragover', function (e) {
        e.preventDefault();
        uploadZone.classList.add('dragover');
      });
      uploadZone.addEventListener('dragleave', function () {
        uploadZone.classList.remove('dragover');
      });
      uploadZone.addEventListener('drop', function (e) {
        e.preventDefault();
        uploadZone.classList.remove('dragover');
        handleLogoFile(e.dataTransfer.files[0]);
      });
    }

    // Image error handling for photos
    $$('.tl-photo-card img').forEach(function (img) {
      img.addEventListener('error', function () {
        img.style.display = 'none';
        var fallback = img.parentElement.querySelector('.tl-photo-fallback');
        if (fallback) fallback.style.display = 'flex';
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLightbox();
    });

    renderAll();
    renderReorderSection();
    renderReviewFilters();
    renderReviewStrip();
    initInfiniteScroll('.tl-reviews-scroll-wrap');
    initInfiniteScroll('.tl-testimonial-scroll-wrap');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
